import { LitElement, TemplateResult, html } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { AdoptedStyleSheets } from '../../controllers/adopted-stylesheets';
import innerStyles from './styles/outline-book-appointment-card.inner.pcss?inline';
import globalStyles from './styles/outline-book-appointment-card.global.pcss?inline';
import { SlotHelper } from '../../controllers/slot-helper';

/**
 * The OutlineBookAppointmentCard component
 * @element outline-book-appointment-card
 */
@customElement('outline-book-appointment-card')
export class OutlineBookAppointmentCard extends LitElement {
  adoptedStyleSheets = new AdoptedStyleSheets(this, {
    globalCSS: globalStyles,
    encapsulatedCSS: innerStyles,
  });
  private _slotHelper = new SlotHelper(this);

  @property({ type: String, attribute: 'background-color' })
  backgroundColor: 'brand-neutral' | 'primary-subtler';

  @property({ type: Boolean })
  hasHeading: boolean;

  @property({ type: Boolean })
  hasSubheading: boolean;

  @property({ type: Boolean })
  hasButton: boolean;

  @property({ type: Boolean })
  hasContact: boolean;

  render(): TemplateResult {
    this.hasHeading = this._slotHelper.isNotEmpty('heading');
    this.hasSubheading = this._slotHelper.isNotEmpty('subheading');
    this.hasButton = this._slotHelper.isNotEmpty('button');
    this.hasContact = this._slotHelper.isNotEmpty('contact');

    return html`
      <div class=${`book-appointment-card ${this.backgroundColor}`}>
        ${this.hasHeading
          ? html`
              <div class="heading">
                <slot name="heading"></slot>
              </div>
            `
          : null}
        ${this.hasSubheading
          ? html`
              <div class="subheading">
                <slot name="subheading"></slot>
              </div>
            `
          : null}
        ${this.hasButton
          ? html`
              <div class="button">
                <slot name="button"></slot>
              </div>
            `
          : null}
        ${this.hasContact
          ? html`
              <div class="contact">
                <slot name="contact"></slot>
              </div>
            `
          : null}
      </div>
    `;
  }
}
declare global {
  interface HTMLElementTagNameMap {
    'outline-book-appointment-card': OutlineBookAppointmentCard;
  }
}
